// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Qau0","options":"AnswerScale_options__nMc4Y","selected":"AnswerScale_selected__dtX6x"};